<template>
  <disputes-list-table />
</template>
<script>
import DisputesListTable from './busi/disputes-list-table.vue'
export default {
  name: 'DisputesList',
  components: { DisputesListTable },
  data() {
    return { }
  }
}
</script>
